import { render, staticRenderFns } from "./c-quilleditor.vue?vue&type=template&id=1feb567a&scoped=true"
import script from "./c-quilleditor.vue?vue&type=script&lang=js"
export * from "./c-quilleditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feb567a",
  null
  
)

export default component.exports